@if ($list | async; as list) {
  @if (status === 'empty') {
    <p class="empty-list-info">
      {{ 'CAMPAIGN.ACCOUNTS.EMPTY_PAGE_EMAIL' | translate }}
    </p>
  }
  @if (status !== 'loading') {
    <button
      class="btn add-account-btn"
      [disabled]="lockActionsSubject | async"
      (click)="addAccount()">
      {{ 'CAMPAIGN.ACCOUNTS.EMAIL_ACCOUNTS.ADD_BUTTON' | translate }}
    </button>
  }
  @if (status === 'received') {
    <div class="table-wrapper">
      <div class="background-box box"></div>
      @if (status === 'received') {
        <div class="pseudo-table">
          <span class="title status-title">
            {{ 'CAMPAIGN.ACCOUNTS.EMAIL_ACCOUNTS.STATUS' | translate }}
          </span>
          <span class="title">
            {{ 'CAMPAIGN.ACCOUNTS.EMAIL_ACCOUNTS.ACCOUNT_NAME' | translate }}
          </span>
          <span class="title">{{ 'CAMPAIGN.ACCOUNTS.EMAIL_ACCOUNTS.EMAIL' | translate }}</span>
          <span class="title">{{ 'CAMPAIGN.ACCOUNTS.EMAIL_ACCOUNTS.SENT' | translate }}</span>
          <span class="title">{{ 'CAMPAIGN.ACCOUNTS.EMAIL_ACCOUNTS.LIMIT' | translate }}</span>
          @for (credendtial of list; track credendtial.id) {
            <div class="status">
              <label>
                <app-radio class="radio" [checked]="selectedEmail === credendtial"></app-radio>
                <input
                  type="radio"
                  name="credentials"
                  [value]="credential"
                  (change)="selectPrimaryEmail(credendtial)" />
              </label>
              <app-account-status
                [status]="isValid ? 'success' : 'failed'"
                class="status-icon"></app-account-status>
            </div>
            <span class="name">{{ credendtial.fromName }}</span>
            <span class="email">{{ credendtial.fromEmail }}</span>
            <span class="sent">{{ credendtial.sent }}</span>
            <span class="limit">{{ credendtial.dailyLimit }}</span>
            <app-edit-actions
              class="actions"
              (editLimits)="editAccount(credendtial)"
              (delete)="deleteAccount(credendtial)"
              [disabled]="lockActionsSubject | async"
              [isAccountAccessible]="true"></app-edit-actions>
          }
        </div>
      }
    </div>
  }
}
